/** A theme object for different sizes. */
export const layout = {
  borderRadius: 6,
  elevationSize: 3,
  outlineSize: 2,
  shadowSize: 6,
  scale: (value: number) => value * 4,
} as const;
